import request from "../base/request";

let host = "/cm-sites-sys/";

const Apis = {
    getOnlineNumberList: host + 'online/getOnlineUser',//在线人数信息列表
    getOnlineNumber: host + 'online/userOnlineCount', //在线列表人数
};


//在线人数信息列表
export const getOnlineNumberList = (body, callBack, errorCallBack) => {
    request({
        url: Apis.getOnlineNumberList,
        body,
        method: "post",
        contentType: 'json',
        callBack,
        message: {info: errorCallBack}
    });
};

//在线列表人数
export const getOnlineNumber = (body, callBack) => {
    request({url: Apis.getOnlineNumber, body, method: "post", callBack});
};
